import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class BrowserService {
	constructor() { }

	getInternetExplorerVersion() {
		const ua = window.navigator.userAgent;
		const msie = ua.indexOf('MSIE ');

		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		const trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			const rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		return 0;
	}

	getOldEdgeVersion() {
		const ua = window.navigator.userAgent;

		const edge = ua.indexOf('Edge/');
		if (edge > 0) {
		// Edge (IE 12+) => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		return 0;
	}

	isDeprecatedBrowser() {
		return !!(this.getInternetExplorerVersion() || this.getOldEdgeVersion());
	}
}
